import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalOpenerService } from 'src/app/services/modal-opener.service';
import { feedbackModalOpener } from '../feedback-modal/feedback-modal.modal';

@Component({
  selector: 'app-feedback-entry',
  templateUrl: './feedback-entry.component.html',
  styleUrl: './feedback-entry.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackEntryComponent {
  private readonly modalOpener = inject(ModalOpenerService);

  protected onFeedbackButtonClick(): void {
    this.modalOpener.open(feedbackModalOpener);
  }
}
